<br />
<br />
<h1 style="padding-left: 16px">Marketing Material</h1>
<div style="padding: 16px">
  <button
    class="marketing-button"
    mat-button
    (click)="scrollTo(item.category.id)"
    *ngFor="let item of groupedData"
  >
    {{ item.category.descriptor }}
  </button>
</div>
<br />
<ng-container *ngIf="response && response.success">
  <ng-container *ngIf="groupedData">
    <div style="padding: 16px">
      <div
        fxLayout="row wrap"
        *ngFor="let item of groupedData"
        [id]="item.category.id"
      >
        <div fxFlex="100">
          <h3 style="font-weight: bold">
            {{ item.category.descriptor }}
          </h3>
        </div>
        <div
          fxFlex="25"
          fxFlex.lt-sm="100"
          *ngFor="let asset of item.items"
          style="padding: 12px"
        >
          <p [ngStyle]="{ color: asset.fileUrl ? 'black' : 'red' }">
            {{ asset.descriptor }}
          </p>
          <mat-card>
            <mat-card-content style="position: relative">
              <span style="float: right; margin-top: 5px">
                <ng-container
                  *ngIf="
                    asset.marketingItemTypeId == 1 ||
                    asset.marketingItemTypeId == 5 ||
                    asset.marketingItemTypeId == 9
                  "
                >
                  <button
                    mat-icon-button
                    matTooltip="View"
                    color="accent"
                    (click)="view(asset)"
                  >
                    <mat-icon>visibility</mat-icon></button
                  >&nbsp;
                </ng-container>
                <a
                  mat-icon-button
                  matTooltip="Download"
                  target="_blank"
                  color="primary"
                  [href]="asset.fileUrl"
                  ><mat-icon>download</mat-icon></a
                >&nbsp;<button
                  mat-icon-button
                  matTooltip="Copy link"
                  color="accent"
                  [cdkCopyToClipboard]="asset.fileUrl"
                >
                  <mat-icon>link</mat-icon>
                </button>
              </span>
              {{ asset.fileName }}
              <br />
              <p style="margin-top: 6px">
                <small>{{ asset.marketingItemTypeDescriptor }}</small>
              </p>
            </mat-card-content>
          </mat-card>
        </div>
        <div fxFlex="100">
          <br />
          <br />
          <mat-divider></mat-divider>
          <br />
          <br />
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
